<template>
    <v-dialog
        :value="dialog"
        max-width="400"
        @keydown.esc="close"
        @click:outside="close"
    >
        <v-card class="overlay">
            <v-card-title class="headline">
                <slot name="headline"></slot>
            </v-card-title>

            <v-card-actions class="align-center justify-center">
                <v-btn
                    class="ma-2"
                    color="white"
                    outlined
                    @click="btnOne"
                >
                    <slot name="btn-one"></slot>
                </v-btn>
                <v-btn
                    class="ma-2"
                    color="white"
                    outlined
                    @click="btnTwo"
                >
                    <slot name="btn-two"></slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "CommonDialog",

    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        btnOne() {
            this.$emit("btnOne");
        },
        btnTwo() {
            this.$emit("btnTwo");
        },
        close() {
            this.$emit("close");
        },
    }
};
</script>

<style scoped lang="scss">

@import '@/sass/modules/_variables';

.overlay {
    background: $accent-background;
}

</style>